(() => {
  const NOTE_TEXT =
    "This video has been translated from Swiss French into English using artificial intelligence. Thank you for your understanding.";
  const CONTAINER_SELECTOR = ".pswp__video-container";
  const PSWP_SELECTOR = ".pswp";
  const NOTE_CLASS = "pswp__video-note";
  const CONTAINER_CLASS = "pswp__video-container--with-note";
  const POSTER_BUTTON_SELECTOR = '[id^="DeferredPoster-"]';

  function isVideoSlideContainer(container) {
    if (!(container instanceof HTMLElement)) return false;
    return Boolean(container.querySelector("video-media"));
  }

  function syncVideoNote(container) {
    if (!(container instanceof HTMLElement)) return;

    const note = container.querySelector(`.${NOTE_CLASS}`);
    const shouldShow = isVideoSlideContainer(container);

    if (!shouldShow) {
      container.classList.remove(CONTAINER_CLASS);
      if (note) note.remove();
      return;
    }

    container.classList.add(CONTAINER_CLASS);

    if (note) return;

    const textNode = document.createElement("p");
    textNode.className = NOTE_CLASS;
    textNode.textContent = NOTE_TEXT;
    container.appendChild(textNode);
  }

  function syncAllNotes(scope) {
    if (!(scope instanceof HTMLElement)) return;
    scope.querySelectorAll(CONTAINER_SELECTOR).forEach(syncVideoNote);
    pauseBackgroundMedia(scope);
  }

  function handleOverlayVideoClick(event) {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest(POSTER_BUTTON_SELECTOR)) return;

    const container = event.target.closest(CONTAINER_SELECTOR);
    if (!(container instanceof HTMLElement)) return;

    const videoMedia = container.querySelector("video-media");
    if (!(videoMedia instanceof HTMLElement)) return;
    if (videoMedia.hasAttribute("loaded")) return;

    const posterButton = videoMedia.querySelector(POSTER_BUTTON_SELECTOR);
    if (!(posterButton instanceof HTMLButtonElement)) return;
    posterButton.click();
  }

  function pauseBackgroundMedia(pswpRoot) {
    if (!pswpRoot.classList.contains("pswp--open")) return;
    document.querySelectorAll(".deferred-media").forEach((media) => {
      if (media.closest(PSWP_SELECTOR)) return;
      if (typeof media.pause === "function") media.pause();
    });
  }

  function bindPswp(pswpRoot) {
    if (!(pswpRoot instanceof HTMLElement)) return;
    if (pswpRoot.dataset.videoNoteBound === "true") return;
    pswpRoot.dataset.videoNoteBound = "true";

    let rafId = 0;
    const scheduleSync = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = 0;
        if (!pswpRoot.isConnected) return;
        syncAllNotes(pswpRoot);
      });
    };

    syncAllNotes(pswpRoot);
    pswpRoot.addEventListener("click", handleOverlayVideoClick);
    const observer = new MutationObserver(() => {
      scheduleSync();
    });

    observer.observe(pswpRoot, {
      childList: true,
      subtree: true
    });
  }

  function bindPswpFromNode(node) {
    if (!(node instanceof HTMLElement)) return;
    if (node.matches(PSWP_SELECTOR)) bindPswp(node);
    node.querySelectorAll(PSWP_SELECTOR).forEach(bindPswp);
  }

  function init() {
    document.querySelectorAll(PSWP_SELECTOR).forEach(bindPswp);
    if (!document.body) return;

    const rootObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(bindPswpFromNode);
      });
    });

    rootObserver.observe(document.body, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
